<template>
    <div class="user-list user-list-view">
        
        <b-container>
            <button-row :Buttons="Buttons" class="mb-4"></button-row>
                <b-card
                    v-for="(m,i) in members" :key="i"
                    tag="article" class="mb-2 user-list-item">
                        <user-list-item 
                            :user_name="`${m.fe_user_firstname} ${m.fe_user_lastname}`"
                            :user_contact_mobile="m.fe_user_mobile ? m.fe_user_mobile : false"
                            :user_contact_email="m.fe_user_email_private ? m.fe_user_email_private : false"
                            :user_role="m.fe_user_roles"
                            :user_id="m.ID" 
                            :hide_activity_buttons="true"
                            :thumbnail="m.fe_user_photo ? m.fe_user_photo.sizes.TinySquare : ''"
                            :user_active="m.fe_user_active_bool"
                            :user_suspend="m.fe_user_suspend_bool"
                            :user_additional_information="true"
                        ></user-list-item>
                </b-card>

        </b-container>
    </div>
</template>

<script>
import Buttons from '@/components/ButtonRow'
import { mapGetters, mapActions } from "vuex";
import UserListItemVue from '../components/UserListItem.vue';
export default {
    name: 'user-list',
    components: {
        'button-row': Buttons,
        'user-list-item': UserListItemVue
    },
    computed: {
        ...mapGetters('members', ['fetching', 'members']),
        Buttons() {
            const buttons = [
                {
                    title: 'Zurück',
                    to: 'application',
                    variant: 'light border',
                    icons: {
                        left: {
                            icon: ['far', 'arrow-left'],
                            visible: true
                        },
                        right: {
                            icon: ['far', 'arrow-right'],
                            visible: false
                        }
                    }
                }
            ]
            return buttons;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions('members', ['fetchMembers']),

        init() {
            this.fetchMembers();
        }
    }
}
</script>

<style lang="scss">

</style>